import React from 'react';

export default function Splash() {
  return (
    <div className="splash-overlay">
      <div className="text-center px-6">
        <div className="font-mono-label text-[#8E8B85] mb-6 splash-text" style={{ animationDelay: '0.05s' }}>
          THESIS ° EST. 2025 ° BELO HORIZONTE
        </div>
        <h1 className="font-display text-[#F5F1E8] text-[64px] md:text-[140px] leading-[0.85] tracking-[-0.06em] splash-text" translate="no">
          Thesis<span className="text-[#C8FF61] font-serif-italic">°</span>
        </h1>
        <div className="mt-10 mx-auto h-[1px] bg-[#F5F1E8]/20 max-w-[480px] relative overflow-hidden">
          <div className="absolute inset-0 bg-[#C8FF61] splash-line" />
        </div>
        <div className="mt-5 font-mono-label text-[#8E8B85] splash-text" style={{ animationDelay: '0.6s' }}>
          carregando experiência
        </div>
      </div>
    </div>
  );
}
